import script from "./SidebarIO.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarIO.vue?vue&type=script&setup=true&lang=js"

import "./SidebarIO.vue?vue&type=style&index=0&id=7ba31860&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba31860"]])

export default __exports__